<div class="forgot-modal">

  <button type="button" class="forgot-close" (click)="sent ? onDone() : onCancel()" aria-label="Close">
    <i class="bi bi-x-lg"></i>
  </button>

  <ng-container *ngIf="!sent">
    <h1>Reset your password</h1>
    <p class="auth-sub">We'll email you a link to set a new one.</p>

    <form [formGroup]="formControl" (ngSubmit)="submitForm()">
      <div class="field">
        <label for="forgot-email">Email <span class="req">*</span></label>
        <input type="email" id="forgot-email" class="input-form" formControlName="email" placeholder="you@company.com"
          autocomplete="email"
          [class.is-invalid]="formControl.controls.email.touched && !formControl.controls.email.valid" />
        <span class="hint" *ngIf="!error">We'll send a reset link to this address.</span>
        <div class="field-error" *ngIf="error">
          <i class="bi bi-exclamation-circle"></i>
          <span>{{ error }}</span>
        </div>
      </div>

      <button type="submit" class="btn btn-primary btn-block" [disabled]="!formControl.valid || loading">
        <span class="auth-spinner" *ngIf="loading" aria-hidden="true"></span>
        <span *ngIf="!loading">Send reset link</span>
        <span *ngIf="loading">Sending…</span>
      </button>
    </form>
  </ng-container>

  <div class="state-card-success" *ngIf="sent">
    <div class="ico"><i class="bi bi-envelope-check"></i></div>
    <h3>Check your inbox</h3>
    <p>If an account exists for <strong>{{ submittedEmail }}</strong>, a reset link is on its way.</p>
    <button type="button" class="btn btn-secondary btn-block" (click)="onDone()">Done</button>
  </div>

</div>